/*
  MINOÉ — la pastille du panier dit toujours la vérité (29/10/2026)

  LE PROBLÈME. Le compteur de l'en-tête (`cart-icon.js`) ne se met à jour que
  sur l'événement `cart:lines:update` du thème, ou au rendu serveur de la page.
  Rapid Bundle modifie le panier par sa propre requête : le thème ne l'entend
  pas, et la pastille garde l'ancien chiffre jusqu'au chargement suivant.
  Mesuré le 29/10/2026 : au rendu serveur la pastille est juste immédiatement
  (3 sur un panier de 3) ; c'est bien la modification en cours de page qui
  passe inaperçue.

  LA CORRECTION. On observe le RÉSEAU, jamais le DOM ni le style de Rapid :
  dès qu'une requête touche /cart/add, /cart/change, /cart/update ou
  /cart/clear — quelle qu'en soit l'origine — on relit /cart.js, qui fait foi,
  et on écrit le vrai nombre dans la pastille.

  Rien de Rapid n'est lu, modifié ni stylé : on ne regarde que les URL
  appelées, et on n'écrit que dans les éléments du thème.
*/
(function () {
  'use strict';

  var MUTE = /\/cart\/(add|change|update|clear)(\.js|\b)/i;
  var enCours = false;

  function pastille() {
    return document.querySelector('[data-testid="cart-bubble"]');
  }

  function ecrire(n) {
    var compteur = pastille();
    if (!compteur) return;
    var bulle = compteur.closest('.cart-bubble');
    var icone = compteur.closest('cart-icon');

    compteur.textContent = n < 100 ? String(n) : '';
    compteur.classList.toggle('hidden', n === 0);
    if (bulle) bulle.classList.toggle('visually-hidden', n === 0);
    if (icone) icone.classList.toggle('header-actions__cart-icon--has-cart', n > 0);

    /* `cart-icon.js` relit cette valeur au chargement suivant et la fait
       gagner contre le rendu serveur pendant 10 s : on la tient à jour,
       sinon c'est un ancien chiffre qui reviendrait. */
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
    } catch (e) {}
  }

  function resynchroniser() {
    if (enCours) return;
    enCours = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (panier && Number.isInteger(panier.item_count)) ecrire(panier.item_count);
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  /* Une modification du panier peut déclencher plusieurs requêtes à la suite :
     on relit une fois les requêtes terminées, puis une seconde fois un peu
     plus tard pour le cas où l'application écrit en deux temps. */
  function apresModification() {
    setTimeout(resynchroniser, 150);
    setTimeout(resynchroniser, 1200);
  }

  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (entree, options) {
      var url = '';
      try { url = typeof entree === 'string' ? entree : (entree && entree.url) || ''; } catch (e) {}
      var promesse = fetchOrigine.apply(this, arguments);
      if (MUTE.test(url)) promesse.then(apresModification, apresModification);
      return promesse;
    };
  }

  var ouvrirOrigine = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    try { this.__minoeCart = MUTE.test(String(url)); } catch (e) {}
    return ouvrirOrigine.apply(this, arguments);
  };
  var envoyerOrigine = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__minoeCart) this.addEventListener('loadend', apresModification);
    return envoyerOrigine.apply(this, arguments);
  };

  /* Au chargement et au retour arrière : on repart du panier réel. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resynchroniser);
  } else {
    resynchroniser();
  }
  window.addEventListener('pageshow', resynchroniser);
})();

/*
  MINOÉ — le sélecteur de quantité du thème n'a plus rien à faire là
  (29/10/2026)

  C'est Rapid qui compose le pack : une mallette pour Découverte, deux pour le
  Duo, trois pour le Tribu. Le sélecteur de quantité du thème, posé à côté,
  laisse croire à une seconde multiplication et affichait « 2 » par défaut.

  Mesuré le 29/10/2026 : avec le même pack, envoyer une quantité de 1 ou de 2
  donne exactement le même panier — Rapid remplace la charge utile du
  formulaire. Forcer 1 ne change donc rien à ce que Rapid compose, et retire
  l'ambiguïté à l'écran.

  On ne touche ni au style ni au DOM de Rapid : on n'écrit que dans le champ
  `quantity` du formulaire du thème, que Rapid n'utilise pas.
*/
(function () {
  'use strict';

  function forcerUn() {
    var champs = document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]');
    for (var i = 0; i < champs.length; i++) {
      if (champs[i].value !== '1') champs[i].value = '1';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forcerUn);
  } else {
    forcerUn();
  }
  /* Le champ est reconstruit à chaque changement de variante, et le thème y
     réécrit sa valeur par défaut. On surveille donc le document : à chaque
     remplacement du formulaire, on repasse la quantité à 1. */
  document.addEventListener('submit', forcerUn, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(forcerUn, 0);
  }, true);

  if (typeof MutationObserver === 'function') {
    var observateur = new MutationObserver(function () { forcerUn(); });
    var demarrer = function () {
      observateur.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      forcerUn();
    };
    if (document.body) demarrer();
    else document.addEventListener('DOMContentLoaded', demarrer);
  }
})();

/*
  MINOÉ — on ne change pas la quantité d'une ligne de pack (29/10/2026)

  POURQUOI. Mesuré le 29/10/2026 : au-delà de la quantité prévue par le pack,
     Rapi applique le prix unitaire du pack à chaque mallette en plus, au
     lieu du tarif du pack suivant. (Les chiffres de l'offre de l'époque ont
     été retirés de ce commentaire le 01/11/2026 : les prix vivent dans
     Rapi et dans l'admin, jamais dans ce fichier.)
     */
(function () {
  'use strict';

  var CLASSE = 'minoe-ligne-pack';

  function marquer(panier) {
    if (!panier || !panier.items) return;
    var clefs = {};
    for (var i = 0; i < panier.items.length; i++) {
      var props = panier.items[i].properties || {};
      if (props.__rapi_offer || props._rapi_bundles) clefs[panier.items[i].key] = true;
    }
    var lignes = document.querySelectorAll('[data-key]');
    for (var j = 0; j < lignes.length; j++) {
      var estPack = !!clefs[lignes[j].getAttribute('data-key')];
      lignes[j].classList.toggle(CLASSE, estPack);
      if (estPack) {
        var champs = lignes[j].querySelectorAll('input[name="quantity"], input[name="updates[]"], input[type="number"]');
        for (var k = 0; k < champs.length; k++) {
          champs[k].readOnly = true;
          champs[k].setAttribute('aria-readonly', 'true');
        }
      }
    }
  }

  function relire() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(marquer)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relire);
  } else {
    relire();
  }
  window.addEventListener('pageshow', relire);
  /* Le tiroir et le tableau du panier sont redessinés à chaque modification :
     on remarque les lignes après chaque redessin. */
  document.addEventListener('cart:lines:update', function () { setTimeout(relire, 400); });
  if (typeof MutationObserver === 'function') {
    var minuteur = null;
    var obs = new MutationObserver(function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(relire, 300);
    });
    var lancer = function () { obs.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) lancer();
    else document.addEventListener('DOMContentLoaded', lancer);
  }
})();


/*
  MINOÉ — le séparateur du bandeau d'annonce est le bouton du logo
  (29/10/2026)

  Le réglage « text » du bandeau refuse l'attribut `class` : impossible d'y
  écrire le span depuis le template. On remplace donc le « · » après coup,
  dans la page. Le texte reste lisible tel quel si le script ne tourne pas.
*/
(function () {
  'use strict';
  function poser() {
    var lignes = document.querySelectorAll('.announcement-bar__text');
    for (var i = 0; i < lignes.length; i++) {
      var l = lignes[i];
      if (l.querySelector('.minoe-sep-logo')) continue;
      if (l.textContent.indexOf('\u00b7') === -1) continue;
      l.innerHTML = l.innerHTML.replace(
        /\s*\u00b7\s*/,
        '<span class="minoe-sep-logo" aria-hidden="true"></span>'
      );
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser);
  else poser();
  window.addEventListener('pageshow', poser);
})();

/* ------------------------------------------------------------------ *
 * 5. Galerie produit : elle doit couvrir AU MOINS la hauteur de la
 *    colonne d'achat. Rendu le 29/10/2026 apres mesure en ligne.
 *
 *    Deux choses se cumulaient :
 *    - le reglage « constrain_to_viewport » du bloc galerie n'affichait
 *      que 5 media sur 20 (les autres en display:none) ;
 *    - la premiere version de ce script REPLIAIT la galerie, alors que
 *      le probleme etait l'inverse : elle etait trop courte.
 *
 *    Ici on travaille sur les <li> de la grille, par RANGEES COMPLETES
 *    de deux : on en garde assez pour depasser la hauteur de la colonne,
 *    et le reste part derriere « Voir toutes les photos ».
 *    La hauteur est relue apres le chargement complet (polices, bloc Rapi,
 *    etoiles Judge.me) et a chaque changement de largeur de fenetre.
 * ------------------------------------------------------------------ */
(function () {
  var LIBELLE = 'Voir toutes les photos';
  var LIBELLE_MOINS = 'Voir moins de photos';
  var COLONNES = 2;

  /* 29/10/2026, phase 2 : la galerie ne change PLUS selon le coloris.
     Une seule galerie commune, bleu + rose, de 13 media dans l'ordre
     decide par la fondatrice. Les media suivants du produit restent dans
     l'admin (rien n'est supprime) mais sortent de la galerie. */
  var N_GALERIE = 20;

  function colonne() {
    var a = document.querySelector('#achat');
    if (!a) return null;
    return a.closest('[class*="product-details"], .product-information__details, .group-block');
  }

  function grille() { return document.querySelector('ul.media-gallery__grid'); }
  function bouton(gal) { return gal.parentElement.querySelector('[data-minoe-plus]'); }

  function texte(el) {
    var m = el && el.querySelector('img, video');
    return (m && (m.getAttribute('alt') || m.getAttribute('aria-label'))) || '';
  }

  /* ---------------------------------------------------------------- *
   * Premiere image : bleue par defaut, rose UNIQUEMENT si l'offre
   * « Decouverte » (1 mallette) est choisie avec le coloris Rose licorne.
   *
   * On LIT le bloc Rapi, on n'y touche pas : ni style, ni DOM. Les
   * boutons radio « rapi-bundles-deal-… » donnent l'offre (0 = Decouverte)
   * et le menu « rapi_option_0_0_0 » donne le coloris de cette offre.
   * ---------------------------------------------------------------- */
  function decouverte_rose() {
    var radios = document.querySelectorAll('input[type="radio"][name^="rapi-bundles-deal"]');
    if (!radios.length) return false;
    var i = -1;
    for (var k = 0; k < radios.length; k++) { if (radios[k].checked) { i = k; break; } }
    if (i !== 0) return false;
    /* Attention : « rapi_option_0_0_0 » est une CLASSE du menu, pas son nom.
       Les menus de Rapi n'ont pas d'attribut name. */
    var sel = document.querySelector('select.rapi_option_0_0_0');
    if (!sel) return false;
    return /rose|licorne/i.test(sel.value || '');
  }

  /* L'adresse de la mallette entrouverte rose est posee par le theme
     (snippet product-media-gallery-content), pas devinee dans le DOM. */
  function source_rose() {
    return document.querySelector('[data-minoe-rose-src]');
  }

  function premiere_image(items) {
    if (!items.length) return;
    var prem = items[0].querySelector('img');
    var rose = source_rose();
    if (!prem || !rose) return;
    if (!prem.hasAttribute('data-minoe-bleu-src')) {
      prem.setAttribute('data-minoe-bleu-src', prem.getAttribute('src') || '');
      prem.setAttribute('data-minoe-bleu-srcset', prem.getAttribute('srcset') || '');
      prem.setAttribute('data-minoe-bleu-alt', prem.getAttribute('alt') || '');
    }
    var veut = decouverte_rose();
    if (veut) {
      prem.setAttribute('src', rose.getAttribute('data-minoe-rose-src') || '');
      prem.removeAttribute('srcset');
      prem.setAttribute('alt', rose.getAttribute('data-minoe-rose-alt') || '');
    } else {
      prem.setAttribute('src', prem.getAttribute('data-minoe-bleu-src') || '');
      if (prem.getAttribute('data-minoe-bleu-srcset')) prem.setAttribute('srcset', prem.getAttribute('data-minoe-bleu-srcset'));
      prem.setAttribute('alt', prem.getAttribute('data-minoe-bleu-alt') || '');
    }
  }

  /* La video de la scene du bebe tourne toute seule, en sourdine, en
     boucle, des l'arrivee sur la page. On garde le conteneur d'Horizon :
     on ne fait que poser les attributs et lancer la lecture. */
  function video_auto() {
    [].slice.call(document.querySelectorAll('ul.media-gallery__grid video')).forEach(function (v) {
      v.muted = true;
      v.loop = true;
      v.autoplay = true;
      v.setAttribute('muted', '');
      v.setAttribute('loop', '');
      v.setAttribute('autoplay', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (v.paused) { var j = v.play(); if (j && j.catch) j.catch(function () {}); }
    });
  }

  /* 30/10/2026 : la premiere image tient DEUX colonnes. Avec un nombre pair
     de vignettes derriere elle, la derniere rangee restait a moitie vide.
     Dans ce cas, la derniere vignette visible prend elle aussi toute la
     largeur : aucune case vide, et aucune photo retiree. */
  function pleine_largeur(items, combien, grande) {
    items.forEach(function (e) { e.removeAttribute('data-minoe-large'); });
    if (!grande || combien < 2) return;
    if ((combien - 1) % 2 === 1) items[combien - 1].setAttribute('data-minoe-large', '');
  }

  /* 30/10/2026 — DEUX ROUTINES SEPAREES.

     `rafraichir()` ne touche qu'au contenu : la 1re image (bleue ou rose)
     et la lecture de la video. Elle peut tourner a chaque clic.

     `ajuster()` REPLIE la galerie sur la hauteur de la colonne d'achat.
     Elle mesure, donc elle change la hauteur de la page : elle ne doit
     tourner qu'au chargement et quand la LARGEUR de l'ecran change.

     Pourquoi : elle etait relancee a chaque clic. Ouvrir une question de
     la FAQ rallongeait la colonne d'achat, la galerie se depliait d'une
     rangee, et toute la colonne de droite sautait de plusieurs centaines
     de pixels — le bouton « Voir toutes les photos » apparaissait et
     disparaissait au passage. */
  function rafraichir() {
    var gal = grille();
    if (!gal) return;
    var tous = [].slice.call(gal.children);
    if (!tous.length) return;
    tous.forEach(function (e, i) {
      e.removeAttribute('data-minoe-autre-coloris');
      if (i >= N_GALERIE) e.setAttribute('data-minoe-hors-galerie', '');
      else e.removeAttribute('data-minoe-hors-galerie');
    });
    premiere_image(tous);
    video_auto();
  }

  function ajuster() {
    rafraichir();
    var gal = grille();
    if (!gal) return;
    var tous = [].slice.call(gal.children);
    if (!tous.length) return;

    /* Les media hors des 13 sortent de la galerie, sur ordinateur comme
       sur mobile. L'ancien filtre par coloris est retire. */
    tous.forEach(function (e, i) {
      e.removeAttribute('data-minoe-autre-coloris');
      if (i >= N_GALERIE) e.setAttribute('data-minoe-hors-galerie', '');
      else e.removeAttribute('data-minoe-hors-galerie');
    });
    var items = tous.slice(0, N_GALERIE);

    // Mobile : carrousel, on remet tout ce qui est dans les 13.
    if (window.matchMedia('(max-width: 749px)').matches) {
      items.forEach(function (e) { e.removeAttribute('data-minoe-cachee'); });
      var b0 = bouton(gal); if (b0) b0.remove();
      return;
    }

    var col = colonne();
    if (!col) return;

    items.forEach(function (e) { e.removeAttribute('data-minoe-cachee'); });

    var cible = col.getBoundingClientRect().height;
    if (!cible) return;

    var grande_ouverte = gal.classList.contains('media-gallery--large-first-image') ||
                 (gal.parentElement && gal.parentElement.className.indexOf('large-first-image') >= 0);

    // Galerie depliee par l'utilisatrice : on laisse tout visible.
    if (gal.hasAttribute('data-minoe-ouverte')) {
      pleine_largeur(items, items.length, grande_ouverte);
      var bo = bouton(gal);
      if (bo) bo.textContent = LIBELLE_MOINS;
      return;
    }

    var haut = gal.getBoundingClientRect().top;
    var garde = items.length;

    for (var i = 0; i < items.length; i += COLONNES) {
      var bas = 0;
      for (var k = i; k < Math.min(i + COLONNES, items.length); k++) {
        bas = Math.max(bas, items[k].getBoundingClientRect().bottom - haut);
      }
      if (bas >= cible) { garde = Math.min(i + COLONNES, items.length); break; }
    }

    /* La premiere image occupe les DEUX colonnes (« large_first_image ») :
       pour ne jamais laisser de case vide en bas a droite, on garde
       1 + un nombre PAIR de vignettes, soit un total IMPAIR. */
    var grande = gal.classList.contains('media-gallery--large-first-image') ||
                 (gal.parentElement && gal.parentElement.className.indexOf('large-first-image') >= 0);
    if (grande && garde < items.length && garde % 2 === 0) garde += 1;
    if (garde > items.length) garde = items.length;
    pleine_largeur(items, garde, grande);

    var b = bouton(gal);
    if (garde >= items.length) {
      if (b) b.remove();
      return;
    }

    for (var j = garde; j < items.length; j++) {
      items[j].setAttribute('data-minoe-cachee', '');
    }
    dernierGarde = garde;

    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'minoe-voir-photos';
      b.setAttribute('data-minoe-plus', '');
      b.addEventListener('click', function () {
        if (gal.hasAttribute('data-minoe-ouverte')) {
          gal.removeAttribute('data-minoe-ouverte');
          ajuster();
          var dest = gal.getBoundingClientRect().top + window.pageYOffset - 24;
          window.scrollTo({ top: dest, behavior: 'smooth' });
        } else {
          gal.setAttribute('data-minoe-ouverte', '');
          [].slice.call(gal.querySelectorAll('[data-minoe-cachee]')).forEach(function (e) {
            e.removeAttribute('data-minoe-cachee');
          });
          b.textContent = LIBELLE_MOINS;
        }
      });
      gal.parentElement.appendChild(b);
    }
    b.textContent = gal.hasAttribute('data-minoe-ouverte') ? LIBELLE_MOINS : LIBELLE;
  }

  /* ------------------------------------------------------------------
     LE SAUT DE PAGE AU CLIC DANS RAPI.

     Chaque clic dans Rapi (pack ou coloris) change la variante : le theme
     re-rend la section produit et remplace les <li> de la galerie par du
     HTML frais. Nos attributs `data-minoe-cachee` partent avec eux, la
     galerie se deplie d'un coup, la page grandit de plusieurs centaines
     de pixels — et comme la position de defilement ne bouge pas, tout le
     contenu descend : a l'ecran, on a l'impression d'etre remonte au
     titre et au debut de la galerie.

     On re-applique donc le repli des que les attributs disparaissent, en
     reutilisant le nombre DEJA mesure (aucune nouvelle mesure, aucun
     defilement), et on remet la position exacte si elle a bouge.
     Rien n'est ecrit dans Rapi : on repare notre propre repli.
     ------------------------------------------------------------------ */
  var dernierGarde = null;

  function conteneurDefilant() {
    return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
  }

  function reposerRepli() {
    if (dernierGarde == null) return;
    var gal = grille();
    if (!gal) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;
    if (gal.hasAttribute('data-minoe-ouverte')) return;
    var tous = [].slice.call(gal.children);
    var items = tous.slice(0, N_GALERIE);
    if (items.length <= dernierGarde) return;
    if (items[dernierGarde] && items[dernierGarde].hasAttribute('data-minoe-cachee')) return; // deja replie

    var boite = conteneurDefilant();
    var position = boite.scrollTop;

    tous.forEach(function (e, i) {
      if (i >= N_GALERIE) e.setAttribute('data-minoe-hors-galerie', '');
    });
    for (var j = dernierGarde; j < items.length; j++) {
      items[j].setAttribute('data-minoe-cachee', '');
    }
    premiere_image(tous);
    video_auto();

    if (boite.scrollTop !== position) boite.scrollTop = position;
  }

  if (window.MutationObserver) {
    document.addEventListener('DOMContentLoaded', function () {
      var hote = document.querySelector('.shopify-section[id*="__achat"]') ||
                 document.querySelector('.shopify-section[id*="accueil-choix"]');
      if (!hote) return;
      new MutationObserver(reposerRepli).observe(hote, { childList: true, subtree: true });
    });
  }

  /* Quand Rapi change d'offre ou de coloris, le theme refait la galerie :
     les <li> sont remplaces et nos attributs partent avec eux. On repasse
     donc plusieurs fois, le temps que le nouveau rendu soit en place —
     mais SANS remesurer le repli. */
  function relancer() {
    [200, 900, 1800, 3000].forEach(function (d) {
      setTimeout(function () { rafraichir(); reposerRepli(); }, d);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(ajuster, 500); });
  } else {
    setTimeout(ajuster, 500);
  }
  window.addEventListener('load', function () { setTimeout(ajuster, 600); setTimeout(ajuster, 2000); });

  /* Seule la LARGEUR relance le repli. Une barre d'adresse mobile qui se
     retracte change la hauteur, pas la mise en page : on l'ignore. */
  var largeur = window.innerWidth;
  var minuteur;
  window.addEventListener('resize', function () {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    clearTimeout(minuteur);
    minuteur = setTimeout(ajuster, 180);
  });

  /* Un changement d'offre ou de coloris dans Rapi, ou de variante dans le
     theme : on relit le CONTENU seulement, sans jamais ecrire dans Rapi
     ni remesurer la hauteur de la colonne. */
  document.addEventListener('change', relancer, true);
  document.addEventListener('click', relancer, true);
  document.addEventListener('variant:change', relancer, true);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { setTimeout(ajuster, 300); }); }
})();

/* ------------------------------------------------------------------ *
 * 6. Bulles « stories » : le lecteur plein ecran. 29/10/2026.
 *
 *    Chaque cercle contient deja sa video, qui tourne en sourdine.
 *    Au clic, on ouvre la MEME video en grand, avec precedent, suivant
 *    et une croix. On ne duplique pas les fichiers : le lecteur reprend
 *    la source du cercle choisi.
 * ------------------------------------------------------------------ */
(function () {
  var visio, video, titre;

  function sources() {
    return [].slice.call(document.querySelectorAll('.minoe-story'));
  }

  function construire() {
    if (visio) return visio;
    visio = document.createElement('div');
    visio.className = 'minoe-visio';
    visio.hidden = true;
    visio.setAttribute('role', 'dialog');
    visio.setAttribute('aria-modal', 'true');
    visio.setAttribute('aria-label', 'Vidéos MINOÉ');
    visio.innerHTML =
      /* preload="none" : l'original lourd n'est telecharge qu'au clic.
         Les cercles, eux, tournent sur des copies allegees. */
      '<video class="minoe-visio__video" autoplay muted loop playsinline controls preload="none" disablepictureinpicture></video>' +
      '<button type="button" class="minoe-visio__prec" aria-label="Vidéo précédente">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="minoe-visio__suiv" aria-label="Vidéo suivante">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<button type="button" class="minoe-visio__fermer" aria-label="Fermer">&times;</button>';
    document.body.appendChild(visio);
    video = visio.querySelector('video');

    visio.querySelector('.minoe-visio__fermer').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); fermer();
    });
    visio.querySelector('.minoe-visio__prec').addEventListener('click', function (e) { e.stopPropagation(); aller(-1); });
    visio.querySelector('.minoe-visio__suiv').addEventListener('click', function (e) { e.stopPropagation(); aller(1); });
    // un clic sur le fond ferme, un clic sur la video non
    visio.addEventListener('click', function (e) { if (e.target === visio) fermer(); });
    document.addEventListener('keydown', function (e) {
      if (visio.hidden) return;
      if (e.key === 'Escape') fermer();
      if (e.key === 'ArrowLeft') aller(-1);
      if (e.key === 'ArrowRight') aller(1);
    });
    return visio;
  }

  var courant = 0;

  function montrer(i) {
    var liste = sources();
    if (!liste.length) return;
    courant = (i + liste.length) % liste.length;
    /* Le lecteur prend l'ORIGINAL, pas la copie allegee du cercle. */
    var plein = liste[courant].getAttribute('data-minoe-plein');
    if (!plein) {
      var src = liste[courant].querySelector('source');
      plein = src ? src.getAttribute('src') : null;
    }
    if (!plein) return;
    video.src = plein;
    video.currentTime = 0;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function aller(pas) { montrer(courant + pas); }

  function ouvrir(i) {
    construire();
    visio.hidden = false;
    visio.style.display = '';
    document.documentElement.style.overflow = 'hidden';
    montrer(i);
  }

  /* 29/10/2026 : au premier clic sur la croix, le lecteur restait a l'ecran
     avec un panneau vide ; il fallait un second clic. On ferme donc D'ABORD,
     puis on vide la video au tour de boucle suivant. Plus d'etat
     intermediaire : un seul clic, croix, Echap ou fond. */
  function fermer() {
    if (!visio || visio.hidden) return;
    visio.hidden = true;
    visio.style.display = 'none';
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      try {
        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch (e) {}
    }, 0);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.minoe-story') : null;
    if (!b) return;
    e.preventDefault();
    ouvrir(sources().indexOf(b));
  });
})();

/* ------------------------------------------------------------------ *
 * 7. Galerie : la visionneuse plein ecran. 29/10/2026.
 *
 *    Le zoom d'Horizon empilait TOUTES les photos en pleine taille
 *    dans une colonne de 11 700 px : l'image s'ouvrait gigantesque et
 *    coupee, avec les miniatures collees a droite. On l'intercepte et
 *    on ouvre notre propre visionneuse : une seule image, entiere,
 *    centree, les miniatures en bas.
 * ------------------------------------------------------------------ */
(function () {
  var vue, media, bande, liste = [], courant = 0;

  function grille() {
    return document.querySelector('ul.media-gallery__grid') ||
           document.querySelector('.product-media-gallery__slideshow');
  }

  function grand(url) {
    if (!url) return '';
    return url.replace(/([?&]width=)\d+/, '$12048');
  }

  /* La liste des media visibles de la galerie, dans l'ordre affiche. */
  function relire() {
    var g = grille();
    liste = [];
    if (!g) return liste;
    [].slice.call(g.children).forEach(function (li) {
      if (li.hasAttribute('data-minoe-hors-galerie')) return;
      var v = li.querySelector('video, deferred-media');
      var img = li.querySelector('img');
      if (!img && !v) return;
      var pm = li.querySelector('[data-media-id]');
      liste.push({
        id: pm ? pm.getAttribute('data-media-id') : '',
        video: v ? (li.querySelector('video') || null) : null,
        est_video: !!v,
        src: img ? grand(img.currentSrc || img.src) : '',
        vignette: img ? (img.currentSrc || img.src) : '',
        alt: img ? (img.getAttribute('alt') || '') : ''
      });
    });
    return liste;
  }

  function construire() {
    if (vue) return vue;
    vue = document.createElement('div');
    vue.className = 'minoe-zoom';
    vue.hidden = true;
    vue.style.display = 'none';
    vue.setAttribute('role', 'dialog');
    vue.setAttribute('aria-modal', 'true');
    vue.setAttribute('aria-label', 'Photos de la mallette MINOÉ');
    vue.innerHTML =
      '<div class="minoe-zoom__scene"><img class="minoe-zoom__media" alt=""></div>' +
      '<div class="minoe-zoom__vignettes"></div>' +
      '<button type="button" class="minoe-zoom__prec" aria-label="Photo précédente">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="minoe-zoom__suiv" aria-label="Photo suivante">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<button type="button" class="minoe-zoom__fermer" aria-label="Fermer">&times;</button>';
    document.body.appendChild(vue);
    media = vue.querySelector('.minoe-zoom__media');
    bande = vue.querySelector('.minoe-zoom__vignettes');

    vue.querySelector('.minoe-zoom__fermer').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); fermer();
    });
    vue.querySelector('.minoe-zoom__prec').addEventListener('click', function (e) { e.stopPropagation(); aller(-1); });
    vue.querySelector('.minoe-zoom__suiv').addEventListener('click', function (e) { e.stopPropagation(); aller(1); });
    vue.addEventListener('click', function (e) {
      if (e.target === vue || e.target.classList.contains('minoe-zoom__scene')) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (!vue || vue.hidden) return;
      if (e.key === 'Escape') fermer();
      if (e.key === 'ArrowLeft') aller(-1);
      if (e.key === 'ArrowRight') aller(1);
    });
    return vue;
  }

  function vignettes() {
    bande.innerHTML = '';
    liste.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'minoe-zoom__vignette';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.innerHTML = '<img src="' + m.vignette + '" alt="">';
      b.addEventListener('click', function (e) { e.stopPropagation(); montrer(i); });
      bande.appendChild(b);
    });
  }

  function montrer(i) {
    if (!liste.length) return;
    courant = (i + liste.length) % liste.length;
    var m = liste[courant];
    media.src = m.src;
    media.alt = m.alt;
    [].slice.call(bande.children).forEach(function (b, k) {
      b.setAttribute('aria-current', k === courant ? 'true' : 'false');
    });
    var actif = bande.children[courant];
    if (actif && actif.scrollIntoView) actif.scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  function aller(pas) { montrer(courant + pas); }

  function ouvrir(i) {
    construire();
    /* Ceinture et bretelles : le zoom d'Horizon est desactive dans le
       template, mais s'il s'ouvrait quand meme, un <dialog> passe
       au-dessus de tout. On le referme. */
    [].slice.call(document.querySelectorAll('dialog.dialog-zoomed-gallery__dialog[open]'))
      .forEach(function (d) { try { d.close(); } catch (e) {} });
    relire();
    if (!liste.length) return;
    vignettes();
    vue.hidden = false;
    vue.style.display = '';
    document.documentElement.style.overflow = 'hidden';
    montrer(i);
  }

  function fermer() {
    if (!vue || vue.hidden) return;
    vue.hidden = true;
    vue.style.display = 'none';
    document.documentElement.style.overflow = '';
    setTimeout(function () { media.removeAttribute('src'); }, 0);
  }

  /* On intercepte AVANT Horizon : phase de capture, et on arrete la
     propagation pour que sa boite de zoom ne s'ouvre jamais. La video
     garde son comportement normal : on ne la detourne pas. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.minoe-zoom, video, deferred-media')) return;
    /* Ordinateur : les <li> de la mosaique. Mobile : les <slideshow-slide>
       du carrousel, qui portent le meme data-media-id. On repere donc le
       media par son identifiant, pas par sa position dans le DOM. */
    var cadre = e.target.closest('.product-media-container, slideshow-slide, ul.media-gallery__grid > li');
    if (!cadre) return;
    if (!cadre.closest('ul.media-gallery__grid, slideshow-container, .media-gallery')) return;
    var porteur = cadre.querySelector('[data-media-id]') || cadre.closest('[data-media-id]');
    var id = porteur ? porteur.getAttribute('data-media-id') : '';
    relire();
    var i = -1;
    for (var k = 0; k < liste.length; k++) { if (liste[k].id && liste[k].id === id) { i = k; break; } }
    if (i < 0) return;
    e.preventDefault();
    e.stopPropagation();
    ouvrir(i);
  }, true);
})();

/* ------------------------------------------------------------------ *
 * 8. Pied de page : « Preferences de cookies ». 30/10/2026.
 *
 *    Le pied de page n'accepte pas de bloc Liquid : le lien est un
 *    simple <a href="#preferences-cookies"> pose dans un bloc de texte,
 *    et c'est ici qu'on ouvre le panneau de la banniere.
 *    Le bouton « Retractation » n'est pas touche.
 * ------------------------------------------------------------------ */
(function () {
  document.addEventListener('click', function (e) {
    /* Tout lien qui SE TERMINE par #preferences-cookies : le lien du menu
       vaut « /pages/contact#preferences-cookies », pas l'ancre seule. */
    var a = e.target.closest ? e.target.closest('a[href$="#preferences-cookies"]') : null;
    if (!a) return;
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  }, true);
})();

/* ------------------------------------------------------------------ *
 * 9. Panier : la pastille de quantite, et le tiroir qui se remplit.
 *    30/10/2026.
 *
 *    - Une pastille « x2 » sur la vignette des lignes de 2 articles ou
 *      plus, comme au paiement. Les prix ne bougent pas : l'unitaire
 *      reste sous le nom, le total de la ligne a droite.
 *    - Le tiroir s'ouvrait parfois sur « Votre panier est vide » pendant
 *      que l'ajout de Rapi finissait : on relit /cart.js et on redemande
 *      le rendu du tiroir au serveur. On ne touche pas a Rapi.
 * ------------------------------------------------------------------ */
(function () {
  var enCours = false;

  /* 30/10/2026 — PERIMETRE STRICT. On ne selectionne QUE les lignes du
     panier : la classe `cart-items__table-row` du theme, et seulement a
     l'interieur d'un conteneur de panier. Rapi n'emet jamais `data-key`
     (verifie dans rapi-v2.js, -widget.js, -shared.js, -tpl-prestige.js :
     zero occurrence), mais on ne laisse aucune chance a un croisement :
     rien de ce script ne peut sortir du panier. */
  var PANIERS = '.cart-drawer__inner, .cart-items-component, cart-items, #cart-drawer-section, .cart-items';

  function lignes() {
    var hotes = [].slice.call(document.querySelectorAll(PANIERS));
    var vues = [];
    hotes.forEach(function (h) {
      [].slice.call(h.querySelectorAll('tr.cart-items__table-row[data-key]')).forEach(function (l) {
        if (vues.indexOf(l) < 0) vues.push(l);
      });
    });
    return vues;
  }

  function poserBadges(panier) {
    var q = {};
    panier.items.forEach(function (i) { q[i.key] = i.quantity; });
    lignes().forEach(function (l) {
      var cle = l.getAttribute('data-key');
      /* Le <a> de la vignette porte `overflow: hidden` en style INLINE
         (le thème l'ajoute des que le rayon de bordure depasse 0) : un
         badge en debord y etait rogne. On le pose donc sur la CELLULE. */
      var hote = l.querySelector('td.cart-items__media') || l.querySelector('.cart-items__media');
      if (!hote) return;
      var badge = hote.querySelector('.minoe-qte');
      var n = q[cle];
      /* 30/10/2026 : la pastille s'affiche DES ×1, comme dans le widget
         Rapi, pour que les deux se lisent de la meme facon. */
      if (!n) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'minoe-qte';
        badge.setAttribute('aria-hidden', 'true');
        hote.appendChild(badge);
      }
      badge.textContent = '\u00d7' + n;
    });
  }

  /* Le tiroir affiche-t-il le panier vide alors qu'il ne l'est pas ? */
  function tiroirEnRetard(panier) {
    var t = document.querySelector('.cart-drawer__inner');
    if (!t || !panier.item_count) return false;
    return t.classList.contains('cart-drawer--empty') ||
           t.querySelectorAll('[data-key]').length === 0;
  }

  function redemanderTiroir() {
    return fetch('/?section_id=cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var frais = new DOMParser().parseFromString(html, 'text/html');
        var neuf = frais.querySelector('.cart-drawer__inner');
        var vieux = document.querySelector('.cart-drawer__inner');
        if (neuf && vieux) {
          vieux.replaceWith(neuf);
          /* Le tiroir est NEUF : sa capsule n'a plus ses dates. On previent
             minoe-reveal.js, qui ecoute cet evenement. */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(function () {});
  }

  function rafraichirPanier() {
    if (enCours) return;
    enCours = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (tiroirEnRetard(panier)) {
          return redemanderTiroir().then(function () { poserBadges(panier); });
        }
        poserBadges(panier);
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  ['cart:update', 'cart:updated', 'cart:refresh', 'moonbundle-cart-updated',
   'cart-section:restored', 'rapiAtcButtonClicked'].forEach(function (nom) {
    document.addEventListener(nom, function () {
      [0, 400, 1200, 2500].forEach(function (d) { setTimeout(rafraichirPanier, d); });
    }, true);
  });

  document.addEventListener('click', function () {
    [600, 1600, 3000].forEach(function (d) { setTimeout(rafraichirPanier, d); });
  }, true);

  /* ------------------------------------------------------------------
     L'OUVERTURE DU TIROIR APRES UN AJOUT PAR RAPI.

     Rapi poste lui-meme vers /cart/add : le theme ne voit pas passer
     l'ajout, et son ouverture automatique ne se declenche pas. On guette
     donc la requete, des deux facons possibles (fetch et XMLHttpRequest),
     et quand elle REUSSIT on relit /cart.js, on refait le contenu du
     tiroir, puis on l'ouvre.

     On n'ecrit rien dans Rapi : on observe le reseau, c'est tout.
     ------------------------------------------------------------------ */
  var ouvertureEnCours = false;

  function tiroir() { return document.getElementById('cart-drawer'); }

  function ouvrirTiroir() {
    var t = tiroir();
    if (!t || typeof t.open !== 'function') return;
    if (t.isOpen) return;            // deja ouvert : pas de seconde ouverture
    try { t.open(); } catch (e) {}
  }

  function apresAjout() {
    if (ouvertureEnCours) return;    // un seul enchainement a la fois
    ouvertureEnCours = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (!panier || !panier.item_count) return;   // panier vide : on n'ouvre pas
        return redemanderTiroir().then(function () {
          poserBadges(panier);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          ouvrirTiroir();
        });
      })
      .catch(function () {})
      .then(function () { ouvertureEnCours = false; });
  }

  function estUnAjout(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') >= 0;
  }

  if (window.fetch) {
    var fetchOrigine = window.fetch;
    window.fetch = function (entree, options) {
      var url = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
      var p = fetchOrigine.apply(this, arguments);
      if (estUnAjout(url)) {
        p.then(function (rep) {
          if (rep && rep.ok) setTimeout(apresAjout, 150);   // echec : on n'ouvre pas
        }).catch(function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var ouvrirXHR = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      this.__minoeAjout = estUnAjout(url);
      return ouvrirXHR.apply(this, arguments);
    };
    var envoyerXHR = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__minoeAjout) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) setTimeout(apresAjout, 150);
        });
      }
      return envoyerXHR.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rafraichirPanier);
  } else {
    rafraichirPanier();
  }
  window.addEventListener('load', rafraichirPanier);
})();
